import React from 'react';

const Percentage = ({ value }) => {
  const safe = Math.max(0, Math.min(100, Number(value) || 0));

  return (
    <div className='dashboard-percentage'>
      <div className='dashboard-percentage__track'>
        <div
          className='dashboard-percentage__fill'
          style={{ width: `${safe}%` }}
        />
      </div>
      <p className='dashboard-percentage__value'>{safe}%</p>
    </div>
  );
};

export default Percentage;
